import React, { Component } from 'react';
import questionBg from '../../template/utils/images/questionBg.png';
import WithDrawInvestOption from './WithDrawInvestOption';

/**
 * @class WithDrawInvestModal
 */
class WithDrawInvestModal extends Component {

  /**
   *
   * @returns {*} - render
   */
  render() {
    const withDrawInvestModal = (
      <div className="modal fade" id="meep_settings">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                {' '}
                <span> Close </span>
                {' '}
&times;
              </button>
            </div>

            <div className="modal-body p-5">
              <div className="first_step">
                <div className="ques_info">
                  <img src={questionBg} alt="" />
                </div>

                <div className="have_stock_acc">
                  <p>
                        Would you like to withdraw ?
                  </p>
                </div>

                <div className="have_stock_acc_answer">

                  <div className="ans_no">
                    <button
                      type="button"
                      data-dismiss="modal"
                      >
                      No I Dont
                    </button>
                  </div>
                  <div className="ans_yes">
                    <button
                      type="button" id="yes_i_do"
                      data-toggle="modal"
                      data-target="#ftop_settings"
                      data-dismiss="modal"
                    >
                      <span style={{ color: 'white' }}>Yes I Do</span>
                    </button>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
    return (
      <>
        {withDrawInvestModal}
        <WithDrawInvestOption />
      </>
    );
  }
}

export default WithDrawInvestModal;
